import URI from 'urijs'
import Vue from 'vue'
import { config } from '@/plugins/env.config'

async function getFingerPrintValidation(attemptNumber = 1) {
  const fingerPrintUri = new URI(config.fingerprintBaseUrl)
  fingerPrintUri.segment('devices')
  fingerPrintUri.segment('capture')

  const fingerprintBodyConfigurationQuality = config.fingerprintBodyConfigurationQuality
  const fingerprintBodyConfigurationTimeout = config.fingerprintBodyConfigurationTimeout
  const requestFingerprintTimeoutInSeconds = config.requestFingerprintTimeoutInSeconds

  const body = {
    quality: fingerprintBodyConfigurationQuality,
    timeout: fingerprintBodyConfigurationTimeout
  }

  try {
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(
        () => reject(new Error('Request timed out')),
        requestFingerprintTimeoutInSeconds * 1000
      )
    )

    const response = await Promise.race([
      Vue.prototype.$http.post(fingerPrintUri.toString(), body),
      timeoutPromise
    ])

    if (response.status === 204) {
      throw new Error('Fingerprint validation failed')
    }

    return response
    
  } catch (error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds))
      return getFingerPrintValidation(attemptNumber + 1)
    }
    throw error
  }
}

export { getFingerPrintValidation }
